import React from 'react';
import { RadioButtonGroup } from 'framework/form';
import { SOURCING_FILTERS } from '../../useVacancySourcingService';
import { ENGLISH_LEVEL_OPTIONS, MAP_ENGLISH_LEVEL_TO_SHORT } from 'domain/shared/candidate';

const englishLevels = Object.values(ENGLISH_LEVEL_OPTIONS).map(item => {
  return {
    value: item,
    label: MAP_ENGLISH_LEVEL_TO_SHORT[item],
  };
});

type RadioButtonsSourcingFilterProps = Omit<React.ComponentProps<typeof RadioButtonGroup>, 'options' | 'source'>;

const RadioButtonsSourcingFilter = ({ sx, ...props }: RadioButtonsSourcingFilterProps) => {
  return (
    <RadioButtonGroup
      label=""
      source={SOURCING_FILTERS.englishLevel}
      options={englishLevels}
      sx={[
        {
          marginBottom: '0 !important',
          '& > div': {
            flexDirection: 'column',
            '& > label': {
              marginLeft: '10px',
              '& > .MuiRadio-root': { padding: '2px' },
            },
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    />
  );
};

export default RadioButtonsSourcingFilter;
